/**
 * Shared Page Layout Component
 * 
 * Unified layout structure for all static content pages (FAQ, About, Terms, Privacy).
 * Based on the FAQ page pattern with consistent spacing and structure.
 */

import type { ReactNode } from 'react';
import StaticFooter from './StaticFooter';
import PublicHeader from './PublicHeader';
import FloatingHomeButton from './FloatingHomeButton';

interface PageLayoutProps {
  children: ReactNode;
  maxWidth?: 'narrow' | 'standard' | 'wide'; // 3xl, 4xl, 5xl
}

export default function PageLayout({ children, maxWidth = 'standard' }: PageLayoutProps) {
  const maxWidthClass = {
    narrow: 'max-w-3xl',   // About page - more personal/readable
    standard: 'max-w-4xl', // FAQ page - standard content width
    wide: 'max-w-5xl',     // Future use if needed
  }[maxWidth];

  return (
    <div className="min-h-screen bg-oro-bg text-text-primary">
      {/* Header */}
      <PublicHeader />
      
      {/* Content */}
      <main className="flex-1">
        <div className={`${maxWidthClass} mx-auto py-16 px-4`}>
          {children}
        </div>
      </main>

      {/* Footer */}
      <StaticFooter />
      
      {/* Floating Home Button */}
      <FloatingHomeButton />
    </div>
  );
}